<div class="operation-toolbar {{stylingClass}}">
  <div
    class="operation-toolbar__content"
    [ngClass]="{'errorInputFrame errorNoBorder':isInvalid,
                'moreThanOneButton': splitActions.length > 1}"
  >
    <div class="button-group">
      @if (splitActions.length > 1) {
        <div class="split-button-container"><!--split-button on small-screens-->
          <div
            class="split-button"
            [matTooltip]="getTooltipText(currentButton) | translate"
            [matTooltipDisabled]="!isDisabled(currentButton)"
          >
            <button
              mat-flat-button
              class="split-button__action"
              color="primary"
              (click)="runAction(currentButton)"
              [disabled]="isDisabled(currentButton)"
            >
              <span class="bold" [translate]="currentButton.button_text">
                {{ currentButton.button_text | translate }}
              </span>
            </button>

            <button
              mat-flat-button
              color="primary"
              class="split-button__menu"
              [matMenuTriggerFor]="splitOperationMenu"
              [disabled]="isDisabled(currentButton)"
            >
              <mat-icon>
                expand_more
              </mat-icon>
            </button>
          </div>
        </div>
      }

      <mat-menu #splitOperationMenu="matMenu">
        @for (action of splitActions; track $index) {
          <button
            mat-menu-item
            (click)="setCurrentButton($index)"
            [disabled]="action.button_text === currentButton.button_text"
            [ngClass]="{'active': action.button_text === currentButton.button_text}"
          >
            <span>
              {{ action.button_text | translate }}
            </span>
          </button>
        }

      </mat-menu>

      @for (action of toolbarActions; track $index) {
        <div
          class="operation-toolbar__buttons-container"
          [matTooltip]="getTooltipText(action) | translate"
          [matTooltipDisabled]="!isDisabled(action)"
        >
          @if (action.action_type !== 'cancelRegister') {
            <button
              mat-flat-button
              color="primary"
              class="operation-toolbar__save-button operation-toolbar__button"
              (click)="runAction(action)"
              [disabled]="isDisabled(action)"
            >
              <span class="bold">
                {{ action.button_text | translate }}
              </span>
            </button>
          }
          @else {
            <button
              mat-button
              (click)="runAction(action)"
              class="operation-toolbar__button"
            >
              <span class="bold">
                {{ action.button_text | translate }}
              </span>
            </button>
          }
        </div>
      }
    </div>

    <div class="operation-toolbar__column-error">
      @if (isInvalid) {
        <span class="operation-toolbar__error-container">
          <span class="bold error-text-medium-up">
            {{ 'TRANS__SAVE_TOOLBAR__EXIST' | translate }}
          </span>

          <span class="bold">&nbsp;
            {{errorCount}}&nbsp;
          </span>

          <span class="bold">
            {{ 'TRANS__SAVE_TOOLBAR__ERROR' | translate }}
          </span>&nbsp;

          <span class="bold error-text-medium-up">
            {{ 'TRANS__SAVE_TOOLBAR__IN_FORM' | translate }}
          </span>&nbsp;

          <span class="error-help-text">
            {{ 'TRANS__SAVE_TOOLBAR__HELP_TEXT' | translate }}
          </span>

          <a
            mat-button
            color="warn"
            (click)="nextError()"
            class="error-link"
          >
            <span>
              {{ 'TRANS__SAVE_TOOLBAR__SHOW' | translate }}
            </span>

            <span>&nbsp;</span>

            <span>
              {{ 'TRANS__SAVE_TOOLBAR__NEXT_ERROR' | translate }}
            </span>
          </a>
      </span>
      }
    </div>
  </div>
</div>
